import React from "react";
import { Typography } from "@tvg/fuse/typography";

import styles from "../common.module.css";
import { getCreditInformation } from "../../../utils/constants";

export interface AppProps {
  brand: string | undefined;
}

const CreditInfoSection: React.FC<AppProps> = ({ brand }) => {
  const crediInfoText = getCreditInformation(brand);

  return (
    <div
      className={`${styles.footerCreditInfoSection} footer__credit-info-section`}
      data-testid="credit-section"
    >
      <div
        className={`${styles.footerCreditInfoWrapper} footer__credit-info-wrapper`}
      >
        <Typography
          type="paragraph"
          size="m2"
          className={styles.simple_footer__copyright}
          tag="p"
        >
          {crediInfoText}
        </Typography>
      </div>
    </div>
  );
};

export default CreditInfoSection;
